// Only presentation strings are normalized; provider identifiers stay unchanged on the wire.
export function customerPaymentText(value) {
 return String(value ?? '').replace(/\bizzi(?:[\s_-]*pay)?\b/gi, 'Paiement sécurisé');
}
